import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../../api/axios";
import HostEventRulesIntro from "./HostEventRulesIntro";

const internalReturnPath = (value) => {
  const path = String(value || "");
  return path.startsWith("/") && !path.startsWith("//") ? path : "/events/search";
};

export default function HostRulesPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const returnTo = internalReturnPath(location.state?.returnTo);
  const returnState = location.state?.returnState;
  const isHostClaim = location.state?.mode === "claim";
  const hostClaimEventId = location.state?.hostClaimEventId;

  const goBack = () => navigate(returnTo, {
    replace: true,
    ...(returnState === undefined ? {} : { state: returnState }),
  });
  const continueFromRules = async () => {
    if (!isHostClaim) {
      goBack();
      return;
    }
    await api.post("/events/host-rules/ack/", {});
    navigate(returnTo, {
      replace: true,
      state: {
        resumeHostClaimAfterRules: true,
        hostClaimRulesEventId: hostClaimEventId,
      },
    });
  };

  return (
    <HostEventRulesIntro
      onBack={goBack}
      onContinue={continueFromRules}
      reviewOnly={!isHostClaim}
    />
  );
}
